import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'minus'})

export class MinusPipe implements PipeTransform {
  transform(num: number, args?: any): any {
    if (num < 0 || num === 0) {
      return 0;
    } else {
       return num;
    }
  }
}
